<app-slide class="makePaymentSlide" [title]="enterAmountHeading" [supportingText]="enterAmountSubHeading"
    [slideNumber]="number" [active]="active" [slideCompleted]="complete" (click)="onTitleClick()">
    <form [formGroup]="makePaymentForm" (ngSubmit)="onSubmit()">
        <fieldset>
            <legend class="sr-only">{{ enterAmountHeading }}</legend>
            <div class="section">
                <label for="amount">{{ enterAmountBody }}</label>
                <div *ngIf="makePaymentForm.controls.amount.touched">
                    <div *ngIf="makePaymentForm.controls.amount.errors?.required">
                        <span class="help-block" style="line-height: 34px; vertical-align: middle; clear: both;">
                            <i class="fa fa-times-circle-o form-control-feedback"
                                style="position: relative; float: left; margin-right: 5px;"></i>
                            Please enter an amount to pay.
                        </span>
                    </div>
                    <div *ngIf="makePaymentForm.controls.amount.errors?.min">
                        <span class="help-block" style="line-height: 34px; vertical-align: middle; clear: both;">
                            <i class="fa fa-times-circle-o form-control-feedback"
                                style="position: relative; float: left; margin-right: 5px;"></i>
                            Please enter a value greater than or equal to £1.00.
                        </span>
                    </div>
                    <div *ngIf="makePaymentForm.controls.amount.errors?.max">
                        <span class="help-block" style="line-height: 34px; vertical-align: middle; clear: both;">
                            <i class="fa fa-times-circle-o form-control-feedback"
                                style="position: relative; float: left; margin-right: 5px;"></i>
                            Please enter a value less than or equal to £5000.00.
                        </span>
                    </div>
                </div>
                <div class="has-feedback">
                    <div class="form-group form-group--payment input-make-payment-container"
                        [class.has-error]="makePaymentForm.controls.amount.touched && makePaymentForm.controls.amount.invalid">
                        <span class="pound">£</span>
                        <input type="text" id="amount" formControlName="amount" class="form-control" placeholder="0.00"
                            appPaymentsCvcValidator appPaymentsNumberValidator>
                    </div>
                </div>
                <div class="form-group">
                    <div class="btn-set clearfix btn-make-payment-container">
                        <button type="submit" class="btn btn-primary btn-send btn-make-payment"
                            [disabled]="makePaymentForm.invalid" id="btn-submit-make-payment">
                            <span>{{ buttonText }}</span>
                            <!-- <div>
                                <app-spinner></app-spinner>
                            </div> -->
                        </button>
                    </div>
                </div>
            </div>
        </fieldset>
    </form>
</app-slide>